module.exports = __webpack_public_path__ + "static/media/AI & ML Driven Analytics.9d995276.svg";